// extracted by mini-css-extract-plugin
export default {"smartCaptchaInput":"smartCaptchaInput--JA9zz"};